import "./index.css";
import "./globals.css";

import { PostHogProvider } from "posthog-js/react";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import App from "./App";
import resumeStore from "./app/store";
const container = document.getElementById("root");

const options = {
	api_host: "https://us.i.posthog.com",
};

const root = createRoot(container);
root.render(
	<React.StrictMode>
		<PostHogProvider apiKey="phc_hIy7CdutfB6hxbWmEdyduGmHTOYcFPrCZB0VihR1vjx" options={options}>
			<Provider store={resumeStore}>
				<App />
			</Provider>
		</PostHogProvider>
	</React.StrictMode>,
);
